import React, { useEffect, useState } from "react";
import ExecutiveTeam from "../../Components/Front-End/ExecutiveTeams/ExecutiveTeams";
import Banner from "../../Components/Front-End/Banner/Banner";
import BannerImg from "../../assets/Banners/executive-team-banner.webp";
import { ClipLoader } from "react-spinners";

const BOARD_MEMBER_TYPES = [
    { id: 1, typeName: "Board Members" },
    { id: 2, typeName: "Ice Show Planning Committee" },
    { id: 3, typeName: "Banquet Planning Committee" },
    // add more types if needed
];

const BoardMembersPage = () => {
    const [boardMembers, setBoardMembers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchBoardMembers = async () => {
            try {
                const res = await fetch("/api/boardmembers/GetBoardMembers");
                if (!res.ok) throw new Error("Failed to fetch board members");
                const data = await res.json();

                const activeMembers = data.filter((m) => m.isActive);
                setBoardMembers(activeMembers);

                await new Promise((resolve) => setTimeout(resolve, 1000));
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchBoardMembers();
    }, []);

    // Group by hardcoded types
    const groupedByType = BOARD_MEMBER_TYPES.map((type) => ({
        typeName: type.typeName,
        members: boardMembers.filter((m) => m.boardMemberTypeId === type.id),
    }));

    return (
        <div className="bg-gray-50 min-h-screen font-sans">
            <Banner
                heading="Board Members"
                description="Our board members provide dedicated leadership and vision for the Federation Skating Club."
                buttons={[{ title: "Contact Us" }]}
                image={{
                    src: BannerImg,
                    alt: "Board Members Banner",
                }}
            />

            <div className="max-w-7xl mx-auto px-6 py-12">
                {loading ? (
                    <div className="flex items-center justify-center h-64">
                        <ClipLoader color="#ef4444" size={60} />
                    </div>
                ) : error ? (
                    <p className="text-center text-red-600 mt-8 text-lg font-semibold">
                        Error: {error}
                    </p>
                ) : (
                    <>
                        {groupedByType.map(({ typeName, members }) =>
                            members.length > 0 ? (
                                <section key={typeName} className="mb-10">
                                    <div className="max-w-xl mx-auto text-center">
                                        <p className="text-sm font-semibold text-red-600 uppercase tracking-widest mb-3">
                                            Meet our
                                        </p>
                                        <h2 className="text-4xl font-extrabold text-gray-900 mb-4 sm:text-5xl">
                                            {typeName}
                                        </h2>
                                        <div className="h-1 w-20 bg-red-500 rounded-full mx-auto mb-6"></div>
                                        {/* Optional description if needed */}
                                    </div>

                                    <ExecutiveTeam
                                        description=""
                                        teamMembers={members.map((m) => ({
                                            image: {
                                                src: m.imagePath
                                                    ? `fsc-images/board-members/${m.imagePath}`
                                                    : "",
                                                alt: m.name,
                                            },
                                            name: m.name,
                                            jobTitle: m.jobTitle,
                                            description: m.description || "",
                                            email: m.email || "", 
                                        }))}
                                        cardClassName="bg-white rounded-2xl shadow-lg p-6 flex flex-col items-center text-center transition-transform duration-300 hover:scale-[1.03] hover:shadow-2xl"
                                        imageClassName="w-28 h-28 rounded-full object-cover border-4 border-white shadow-md mb-5"
                                        nameClassName="text-xl font-semibold text-gray-900 mb-1"
                                        jobTitleClassName="text-sm text-red-700 font-medium mb-3"
                                        descriptionClassName="text-gray-700 text-sm line-clamp-4 max-w-xs"
                                    />
                                </section>
                            ) : null
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default BoardMembersPage;
